import React, {useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import Select from 'react-select';
import moment from 'moment';

import {DateRangePicker, Radio} from '../../utilites'
import ReportsAside from './ReportsAside'
import {TransactionGroups, TransactionsDetailed} from "./Transactions";
import {authService} from "../../../services/auth-service";
import {transactionsService} from "../../../services/transactions-service";
import {ModalCommonOrder, ModalInboxOperation} from "../modals";
import {generateReport} from "../../../helpers/reports-helper";
import {messages} from '../../../helpers/messages';
import {listRoles, paymentOperationOptions} from '../../../helpers/data-constants';
import {calculationAccess, getUserFromLocalStorage} from '../../../helpers/common';
import {getDepartments} from '../../../redux/actions/handbookAction';

import '../reports.scss'
import '../../../assets/styles/components/_tables.scss'
import '../../../assets/styles/components/_collapse.scss'

import CrossSmallIcon from '../../../assets/icons/cross-small.svg';
import {SESSION_BY_ID} from "../../../constants/token";
import {AVAILABLE_DEPARTMENTS} from "../../../constants/localStorageConstants";
import _debounce from "lodash/debounce";
import {config} from "../../../helpers/config";

const rolesWithoutAccessFormationCreditDebitOperation = [
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.ACCOUNTANT,
    listRoles.BRANCH_DIRECTOR,
    listRoles.GOODS_SPECIALIST
];

const accessByDepartments = [
    listRoles.ACCOUNTANT,
    listRoles.ADMIN,
    listRoles.DIRECTOR,
    listRoles.MARKETER,
];

const ReportsCash = () => {
    const rolesAllCash = [listRoles.ADMIN, listRoles.DIRECTOR, listRoles.ACCOUNTANT, listRoles.MARKETER];
    const successRolesAllCash = calculationAccess(rolesAllCash)
    const {accessFeatures} = useSelector(({user}) => user);
    const {departments, loading} = useSelector(({handbook}) => handbook);
    const {remotelyReports, remoteCashBoxId, remoteUserId,} = useSelector(({remotelyReports}) => remotelyReports)
    const dataActiveCashbox = useRef(authService.getActiveCashBoxId());

    const [type, setType] = useState('')
    const [rerender, setRerender] = useState(0)
    const [asideRerender, setAsideRerender] = useState(0)

    const [modelCreateTransaction, setModelCreateTransaction] = useState(false)
    const [modelCreateTransactionBatch, setModelCreateTransactionBatch] = useState(false)
    const [explanation, setExplanation] = useState('')
    const [disabledSubmitButton, setDisabledSubmitButton] = useState(false)
    const [isFilterSelected, setIsFilterSelected] = useState(false)
    const cashValue = 'CASH';
    const nonCashValue = 'NON_CASH';
    const bankTransaction = 'BANK_TRANSACTION';
    const [timeRange, setTimeRange] = useState({
        startDate: moment().startOf('day'),
        endDate: moment().endOf('day')
    })

    const [tab, setTab] = useState('groups')

    const dispatch = useDispatch();

    const userInfo = getUserFromLocalStorage();
    const userCashBox = JSON.parse(localStorage.getItem(SESSION_BY_ID))
    const goodsSpecialist = userInfo.roles.length === 1 && userInfo.roles.includes(listRoles.GOODS_SPECIALIST);
    const showFormationCreditDebitOperationButton = calculationAccess(rolesWithoutAccessFormationCreditDebitOperation)
    const showAllDepartments = calculationAccess(accessByDepartments);
    const availableDepartments = JSON.parse(localStorage.getItem(AVAILABLE_DEPARTMENTS))
    const branchDirector = userInfo.roles.length === 1 && userInfo.roles.includes(listRoles.BRANCH_DIRECTOR);
    let paymentType = config().paymentType;
    const [selectValue, setSelectValue] = useState(paymentType[0])
    const [cash, setCash] = useState(cashValue)
    const isNonCashOperationCrediton = accessFeatures['non_cash.operations.type']

    const [cashbox, setCashbox] = useState(() => {
            if (successRolesAllCash) {
                return []
            }
            if (branchDirector) {
                return []
            }
            return [{id: dataActiveCashbox.current.value, name: dataActiveCashbox.current.label}]
        }
    )

    const [cashBoxIds, setCashBoxIds] = useState(() => {
        if (goodsSpecialist) {
            return [dataActiveCashbox.current.value]
        }
        if (branchDirector) {
            return availableDepartments
        }
        return []
    })

    const handleTabChange = ({target: {id}}) => {
        setTab(id)
    }

    function handleTimeChange(newValue) {
        setTimeRange(newValue)
        setIsFilterSelected(true)
    }

    const onTransactionSubmit = (entity) => {
        setDisabledSubmitButton(true)
        let cash;
        if (entity?.payment === 'Наличный') cash = cashValue;
        if (entity?.payment === 'Безналичный') cash = nonCashValue;
        if (entity?.payment === 'ЕРИП') cash = bankTransaction;

        let data = {
            type: type,
            section: entity.section.value,
            amount: entity.amount,
            date: entity.date,
            documentNumber: entity.documentNumber,
            description: entity.description,
            accepted: entity.accepted.label,
            cash: cash,
            transactionAdditionalInfo: entity.attachment,
            passport: entity.passport
        }
        transactionsService.createTransactionExternal(data).then(({data}) => {
            setDisabledSubmitButton(false)
            if (type === "CREDIT") {
                generateReport("TRANSACTION_CREDIT", {
                    transactionId: data.id,
                    accepted: entity.accepted.label,
                    attachment: entity.attachment
                })
            } else {
                generateReport("TRANSACTION_DEBIT", {
                    transactionId: data.id,
                    accepted: entity.accepted.label,
                    document: entity.passport,
                    additionalInfo: entity.attachment,
                    description: entity.description
                })
            }

            setModelCreateTransaction(false)
            setRerender(rerender + 1)
            setAsideRerender(asideRerender + 1)
        }).catch(() => {
            setDisabledSubmitButton(false)
        });
    }

    const onTransactionBatchSubmit = (entity) => {
        setDisabledSubmitButton(true)
        let data = {
            type: type,
            section: entity.section.value,
            date: entity.date,
            documentNumber: entity.documentNumber,
            accepted: type === 'CREDIT' ? `${entity.accepted.label}` : (entity.passport ? `${entity.accepted.label}, ${entity.passport}` : entity.accepted.label),
            cashType: paymentOperationOptions.find(option => option.label === entity.cashType)?.value
        }
        if (remotelyReports && remoteCashBoxId && remoteUserId) {
            data = {...data, remoteCashBoxId: remoteCashBoxId.value, remoteUserId: remoteUserId.value}
        }
        transactionsService.createTransactionBatch(data).then(({data}) => {
            setDisabledSubmitButton(false)
            if (data.id === null) {
                return setExplanation(messages[20])
            }
            let payload = {
                transactionId: data.id,
                accepted: entity.accepted.label,
                description: entity.description
            }
            if (type === "CREDIT") {

                generateReport("TRANSACTION_BATCH_CREDIT", payload)
            } else {
                generateReport("TRANSACTION_BATCH_DEBIT", {
                    ...payload,
                    document: entity.passport,
                })
            }

            closeModalTransactionBatch()
        }).catch(() => {
            setDisabledSubmitButton(false)
        });
    }

    const onRevert = () => {
        setAsideRerender(asideRerender + 1)
    }

    const closeModalTransactionBatch = () => {
        setExplanation('')
        setModelCreateTransactionBatch(false)
    }

    const closeModelCreateTransaction = () => setModelCreateTransaction(false)

    const handleGetDepartments = (e, action) => {
        if (action.action === 'input-change') {
            e && dispatch(getDepartments(e, !showAllDepartments));
        }
    };
    const debouncedGetCashBoxes = _debounce(handleGetDepartments, 250)

    const chooseDepartments = (department) => {
        if (branchDirector) {
            const isAllDepartmentsSelected = availableDepartments.length === cashBoxIds.length;

            if (isAllDepartmentsSelected) {
                setCashBoxIds([department.value])
                setCashbox([
                    {id: department.value, name: department.label}
                ])

                return
            }
        }

        if (!cashBoxIds.find((value) => value === department.value)) {
            const newArrDepartments = [...cashBoxIds];

            newArrDepartments.push(department.value);
            setCashBoxIds(newArrDepartments);
            setCashbox(prev => ([
                ...prev,
                {id: department.value, name: department.label}
            ]))
        }
        setIsFilterSelected(true)
    };

    const deleteChoice = (value) => {
        if (accessFeatures['cash.departments.visibility']) {
            if (!goodsSpecialist) {
                const filteredArrDepartments = cashbox.filter((i) => i.id !== value);

                setCashbox(filteredArrDepartments);
                setCashBoxIds(filteredArrDepartments.map(({id}) => id))
            }
        }
    };

    const renderFasets = () => {
        return (
            cashbox.length ?
                cashbox.map((i) => {
                    return (
                        <button
                            type="button"
                            className="search-facet"
                            key={i.id}
                            onClick={() => deleteChoice(i.id)}
                            id="button">
            <span htmlFor="button" className={'not-crossed'}>
              {i.name}
            </span>
                        </button>
                    );
                }) : <button
                    type="button"
                    className="search-facet"
                    id="button">
                <span htmlFor="button" className={'not-crossed'}>
                  Все
                </span>
                </button>
        );
    };

    const resetFasets = () => {
        if (successRolesAllCash && accessFeatures['cash.departments.visibility']) {
            setCashbox([])
            setCashBoxIds([]);
        } else if (branchDirector) {
            setCashbox([])
            setCashBoxIds(availableDepartments);
        } else {
            setCashbox([{id: dataActiveCashbox.current.value, name: dataActiveCashbox.current.label}]);
            setCashBoxIds([dataActiveCashbox.current.value]);
        }
        setSelectValue(paymentType[0])
        setCash(cashValue)
        setTimeRange({
            startDate: moment().startOf('day'),
            endDate: moment().endOf('day')
        })
        setIsFilterSelected(true)
    }

    const selectPaymentType = (i) => {
        setSelectValue(i)
        let selectedPaymentType = null
        if (i.value === 'Наличные операции') selectedPaymentType = cashValue;
        if (i.value === 'Безналичные операции') selectedPaymentType = nonCashValue;
        if (i.value === 'ЕРИП') selectedPaymentType = bankTransaction;
        setCash(isNonCashOperationCrediton ? i.value : selectedPaymentType);
        setIsFilterSelected(true)
    };
    return (
        <>
            <div className="content-inner-data-columns">
                <div className="content-inner-data-container">
                    <div className="content-datatable">
                        <div className="content-datatable-header">
                            <div className="content-datatable-header-actions">
                                <div className="content-datatable-header-left">
                                    {showFormationCreditDebitOperationButton && <div className="action-items">
                                        <button className="action-item" onClick={() => {
                                            setType("CREDIT")
                                            setModelCreateTransaction(true)
                                        }}>
                                            Приходная операция
                                        </button>
                                        <button className="action-item" onClick={() => {
                                            setType("DEBIT")
                                            setModelCreateTransaction(true)
                                        }}>
                                            Расходная операция
                                        </button>
                                        <ModalInboxOperation
                                            isOpen={modelCreateTransaction}
                                            cashBoxName={userCashBox.label}
                                            type={type}
                                            onTransactionSubmit={onTransactionSubmit}
                                            closeModelCreateTransaction={closeModelCreateTransaction}
                                            disabledButton={disabledSubmitButton}
                                        />

                                        <button className="action-item" onClick={() => {
                                            setType("CREDIT")
                                            setModelCreateTransactionBatch(true)
                                        }}>Сводный ордер по приходным операциям
                                        </button>
                                        <button className="action-item" onClick={() => {
                                            setType("DEBIT")
                                            setModelCreateTransactionBatch(true)
                                        }}>Сводный ордер по расходным операциям
                                        </button>

                                        <ModalCommonOrder
                                            isOpen={modelCreateTransactionBatch}
                                            explanation={explanation}
                                            closeModalTransactionBatch={closeModalTransactionBatch}
                                            cashBoxName={(remotelyReports && remoteCashBoxId && remoteUserId) ? remoteCashBoxId?.label : userCashBox.label}
                                            cashBoxId={(remotelyReports && remoteCashBoxId && remoteUserId) ? remoteCashBoxId.value : userCashBox.value}
                                            type={type}
                                            onTransactionBatchSubmit={onTransactionBatchSubmit}
                                            disabledButton={disabledSubmitButton}
                                        />
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-datatable">
                        <div className="content-datatable-header sticky">
                            <div className="d-flex flex-column align-center fullwidth">
                                <div className="content-datatable-header-actions d-flex">
                                    <div className="content-datatable-header-left">
                                        <div className="action-items">
                                            <div className="pillbox-radiogroup" onChange={handleTabChange}>
                                                <Radio pillboxStyle={true} label={'Отчет'} id={'groups'}
                                                       name={'radioTabTransactions'} checked={true} value={tab}/>
                                                <Radio pillboxStyle={true} label={'Транзакции'} id={'transactions'}
                                                       name={'radioTabTransactions'} value={tab}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-datatable-header-right">
                                        <div className="action-items">
                                            <div className="content-datatable-header-search">
                                                <Select
                                                    classNamePrefix="select"
                                                    className="basic-multi-select"
                                                    placeholder="Тип операции"
                                                    options={paymentType}
                                                    value={selectValue}
                                                    onChange={selectPaymentType}
                                                />
                                            </div>
                                            <div className="content-datatable-header-search">
                                                <Select
                                                    classNamePrefix="select"
                                                    className="basic-multi-select"
                                                    placeholder="Введите подразделение"
                                                    isLoading={loading}
                                                    options={departments}
                                                    noOptionsMessage={() => 'Нет результатов'}
                                                    loadingMessage={() => 'Загрузка...'}
                                                    onInputChange={debouncedGetCashBoxes}
                                                    onChange={chooseDepartments}
                                                />
                                            </div>
                                            <DateRangePicker
                                                coverClass={'form-element'}
                                                startDate={timeRange.startDate}
                                                endDate={timeRange.endDate}
                                                onChange={(v) => handleTimeChange(v)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="search-facets">
                                    <div className="search-facets-pillboxes">
                      <span className="not-crossed search-facet">
                        {isNonCashOperationCrediton ? selectValue.label : selectValue.value}
                      </span>
                                    </div>
                                    <div className="search-facets-pillboxes search-facets-reportCash">
                                        <span>Подразделения: </span> {renderFasets()}</div>
                                    {!goodsSpecialist && <div className="search-facets-actions">
                                        <button className="button-icontrigger noborder" onClick={resetFasets}>
                      <span className="icon">
                        <CrossSmallIcon/>
                      </span>
                                            <span>Сбросить</span>
                                        </button>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        {cashBoxIds.length >= 0 && <div className="content-datatable-content">
                            {
                                tab === "groups"
                                    ? <TransactionGroups
                                        availableDepartments={availableDepartments}
                                        branchDirector={branchDirector}
                                        rerender={rerender}
                                        cashBoxIds={cashBoxIds}
                                        startDate={timeRange.startDate}
                                        endDate={timeRange.endDate}
                                        onRevertParent={onRevert}
                                        cash={cash}
                                        successRolesAllCash={successRolesAllCash}
                                        cashBox={cashbox}
                                    />
                                    : <TransactionsDetailed
                                        availableDepartments={availableDepartments}
                                        branchDirector={branchDirector}
                                        rerender={rerender}
                                        startDate={timeRange.startDate}
                                        endDate={timeRange.endDate}
                                        cashBoxIds={cashBoxIds}
                                        onRevert={onRevert}
                                        cash={cash}
                                        successRolesAllCash={successRolesAllCash}
                                        cashBox={cashbox}
                                        isFilterSelected={isFilterSelected}
                                        onFilterSelected={(value) => setIsFilterSelected(value)}
                                    />
                            }
                        </div>}
                    </div>
                </div>
                {cashBoxIds.length >= 0 &&
                    <ReportsAside
                        availableDepartments={availableDepartments}
                        branchDirector={branchDirector}
                        startDate={timeRange.startDate}
                        endDate={timeRange.endDate}
                        cashBoxIds={cashBoxIds}
                        rerender={asideRerender}
                        cash={cashValue}
                        successRolesAllCash={successRolesAllCash}
                        cashBox={cashbox}
                    />
                }
            </div>
        </>
    )

}

export default ReportsCash
